import Service from './abstract';

const defaultHealthWith = {
    with: 'utilityBillsEnabled'
};

class UtilityBills extends Service {
    constructor () {
        super('utilitybills');
    }

    getHealth () {
        return this.get({
            url: `${this.basePath}/health`,
            qs: defaultHealthWith
        });
    }
}

export default new UtilityBills();
